import { render, staticRenderFns } from "./AIResponse.vue?vue&type=template&id=2a9fd654&"
import script from "./AIResponse.vue?vue&type=script&lang=js&"
export * from "./AIResponse.vue?vue&type=script&lang=js&"
import style0 from "./AIResponse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports